
const runEnv = (process.env.VUE_APP_RUN_ENV || 'pro') as string
const nodeEnv = (process.env.NODE_ENV || 'production') as string

type Env =
  | 'dev'
  | 'test'
  | 'uat'
  | 'pre'
  | 'pro'
interface authConfig {
  appCode: string
  systemType: number
}

interface AppConfig {
  appId: string
  apiHost: string
  publicPath: string
  auth: authConfig
  env: Env
  prefix: string
  loginPath: string
  keySSOToken: string
  whiteList: string[]
  DB_NAME: string
}

const getValueByEnv = (mapping: { [key: string]: string }, env = runEnv): string => {
  return mapping[env] || ''
}

const configs: AppConfig = {
  // 应用的唯一标识
  appId: 'Weixun_PortalAdmin',
  // appId: 'Weixun_SalesAdmin',

  DB_NAME: 'Weixun_PortalAdmin__',

  whiteList: ['login-authentication/login/authentication'],

  env: runEnv as Env,

  loginPath: '/login',

  keySSOToken: getValueByEnv({
    dev: 'local_portal_SSO_token',
    test: 'fat_portal_SSO_token',
    uat: 'uat_portal_SSO_token',
    pro: 'portal_SSO_token'
  }),

  prefix: getValueByEnv({
    dev: 'd-portal',
    test: 't-portal',
    uat: 'u-portal',
    pro: 'portal'
  }),

  // 接口的host
  apiHost: getValueByEnv({
    dev: '//d-portal.visioneschool.com',
    test: '//t-portal.visioneschool.com',
    uat: '//u-portal.visioneschool.com',
    pro: '//portal.visioneschool.com'
  }),

  publicPath: getValueByEnv({
    development: '/',
    production: '/'
  }, nodeEnv),

  auth: {
    // 各个环境 用于权限的appCode, 在权限系统中获得
    appCode: getValueByEnv({
      dev: '7ef624d46c334580ba45d2c54fac5cf7',
      fat: '7ef624d46c334580ba45d2c54fac5cf7',
      uat: '',
      pro: ''
    }),

    systemType: 0
  }
}

export default configs
